import { Button } from "@ts-digital/vrc";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "../vapor/tableComplex";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "antd";
import {postRegistrationMultiple } from "../../store/actions/precog";
import LoaderSimple from "../general/loader";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, useIntl } from "react-intl";
import TableFilters from "./tableFilters";
import { getAllWithholdingsList, getWithholdingDetail } from "../../store/actions/precog/withholding";
import { columnsWithholding } from "./columnsConfig";
import WithHoldingDrawerDetail from "./detail/withholding/drawerDetail";
import FixedAsset from "./detail/fixedAsset";
import ToBeAccountantContent from "./toBeAccountantContent/toBeAccountantContent";
import { getCurrencyList } from "../../store/actions/currency";
import { getDashboardData } from "../../store/actions/precog/accounting";
import WidgetsPrecogContainer from "./widgets";
import moment from "moment";
import { areEqualArray } from "../../libs/arrayUtils";
import SectionHeader from "./dashboard/sectionHeader";
import uuidv4 from "uuid/v4";
import { openNotificationWithIcon } from "../../libs/utils";
import AccountantContent from "./accountantContent";
import { getAccountedEntries } from "../../store/actions/precog/accountedEntries";

const PreCogPage = ({isFromBankPayments}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // const jsonCurrency = useSelector(state => state?.currencyList?.currencies);
  // const invoices = useSelector((state) => state.precog.invoicesList.data);
  const withholdings = useSelector((state) => state.precog.allWithHoldingsList.data);
  const withHoldingDetail = useSelector((state) => state.precog.withHoldingDetail.data);
  const isGettingDashboardData = useSelector((state) => state.precog.dashboardData.status?.started);
  const isGettingWithholdings = useSelector((state) => state.precog.allWithHoldingsList.status?.started);
  const currentFilterSelected = useSelector(state => state.precog?.dashboardFilter);
  const [tabActive, setTabActive] = useState(1);
  /** È la prima nextPage derivante la prima chiamata della lista, le altre le fa in ambito infinite scroll */
  const [initialNexPage, setInitialNexPage] = useState(1);
  const [activeFilters, setActiveFilters] = useState(null);
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [allChecked, setAllChecked] = useState(false);

  const [filterChips, setFilterChips] = useState([]);

  /* NOSENSE
  useEffect(() => {
    setTabActive(location.search.includes("false") || location.search === "" ? 1 : 2);
  }, [location]);
*/

  const [movementsFiltersChips, setMovementsFiltersChips] = useState([{
    key: "ALL",
    desc: "Tutti",
    active: false
  },{
    key: "INCOME",
    desc: "Entrate",
    active: false
  },{
    key: "PAYMENTS",
    desc: "Uscite",
    active: false
  }]);

  const [categories, setCategories] = useState(location?.state?.isFromBankPayments ? ["BANK_TRANSACTION"] : []);
  const [docNumberFilter, setDocNumberFilter] = useState(null);
  const [accountCodeFilter, setAccountCodeFilter] = useState(null);
  const [includesFilter, setIncludesFilter] = useState([]);
  const [isActiveValue, setIsActiveValue] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [closeMoreFilter, setCloseMoreFilter] = useState(true);
  const [monthsSelectValue, setMonthsSelectValue] = useState(1);
  const [months, setMonths] = useState([]);
  const [yearFilter, setYearFilter] = useState(null);
  const [quarterFilter, setQuarterFilter] = useState(null);
  const [isBankTransactionActive, setIsBankTransactionActive] = useState(false);
  /** Per evitare il caos dovuto alle chiamate asincrone che mescolano le risposte e fanno sembrare il filtro
   * non funzionante, uso un uuid per capire il corrente
   */
  const [uuidCurrentFilter, setUuidCurrentFilter] = useState(null);

  useEffect(() => {
    setFilterChips([{
      key: "RECEIPT",
      desc: "Corrispettivi",
      active: currentFilterSelected?.categories ? currentFilterSelected?.categories.includes("RECEIPT") : false
    },
    {
      key: "DOCUMENT",
      desc: "Documenti",
      active: currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("DOCUMENT") : false
    },
    {
      key: "SALE",
      desc: "Vendita",
      active: currentFilterSelected?.categories ? currentFilterSelected?.categories?.includes("SALE") : false
    },{
      key: "PURCHASE",
      desc: "Acquisto",
      active: currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("PURCHASE") : false
    },{
      key: "BANK_TRANSACTION",
      desc: "Movimenti bancari",
      active: currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("BANK_TRANSACTION") : false
    },
    {
      key: "FINANCIAL_TRANSACTION",
      desc: "Movimenti finanziari",
      active: currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("FINANCIAL_TRANSACTION") : false
    },
    {
      key: "OTHER_TRANSACTION",
      desc: "Altri movimenti",
      active: currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("OTHER_TRANSACTION") : false
    }]);

    if (!currentFilterSelected) return undefined;

    if (categories !== currentFilterSelected?.categories){
      setCategories(location?.state?.isFromBankPayments ? ["BANK_TRANSACTION"] : (currentFilterSelected?.categories || []) );
    }
    if (docNumberFilter !== currentFilterSelected?.docNumberFilter)
      setDocNumberFilter(currentFilterSelected?.docNumber);
    if (accountCodeFilter !== currentFilterSelected?.accountCodeFilter)
      setAccountCodeFilter(currentFilterSelected?.accountCodeFilter);
    if (includesFilter !== currentFilterSelected?.includesFilter)
      setIncludesFilter(currentFilterSelected?.includesFilter || []);
    if (isActiveValue !== currentFilterSelected?.isActiveValue)
      setIsActiveValue(currentFilterSelected?.isActiveValue);
    if (dateFrom !== currentFilterSelected?.dateFrom)
      setDateFrom(currentFilterSelected?.dateFrom);
    if (dateTo !== currentFilterSelected?.dateTo)
      setDateTo(currentFilterSelected?.dateTo);

    return () => {

    };
  }, []);

  useEffect(() => {
    if (tabActive === 3) dispatch(getAllWithholdingsList());
  }, [tabActive]);

  useEffect(() => {
    // TODO Rifattorizzare
    setFilterChips([{
      key: "RECEIPT",
      desc: "Corrispettivi",
      active: isFromBankPayments ? false : currentFilterSelected?.categories ? currentFilterSelected?.categories.includes("RECEIPT") : false
    },
    {
      key: "DOCUMENT",
      desc: "Documenti",
      active: isFromBankPayments ? false : currentFilterSelected?.categories ? currentFilterSelected?.categories.includes("DOCUMENT") : false
    },
    {
      key: "SALE",
      desc: "Vendita",
      active: isFromBankPayments ? false : currentFilterSelected?.categories ? currentFilterSelected?.categories?.includes("SALE") : false
    },{
      key: "PURCHASE",
      desc: "Acquisto",
      active: isFromBankPayments ? false : currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("PURCHASE") : false
    },{
      key: "BANK_TRANSACTION",
      desc: "Movimenti bancari",
      active: isFromBankPayments ? true : currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("BANK_TRANSACTION") : false
    },
    {
      key: "FINANCIAL_TRANSACTION",
      desc: "Movimenti finanziari",
      active: isFromBankPayments ? true : currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("FINANCIAL_TRANSACTION") : false
    },
    {
      key: "OTHER_TRANSACTION",
      desc: "Altri movimenti",
      active: isFromBankPayments ? true : currentFilterSelected?.categories ?  currentFilterSelected?.categories?.includes("OTHER_TRANSACTION") : false
    }]);
  }, [isFromBankPayments]);

  useEffect(() => {
    /** dato che in registrazione manuale si può cambiare la currency,
   *  devo avere la lista disponibile */
    dispatch(getCurrencyList());

    return () => {
      dispatch({type: "CLEAR_CURRENCY_LIST"});
    };

  }, []);

  const feedbackMessageSuccess = useIntl().formatMessage({
    id: "preCog.feedbackMessageSuccess"
  });
  const feedbackMessageError = useIntl().formatMessage({
    id: "preCog.feedbackMessageError"
  });

  useEffect(() => {
    const activeCategoriesArray = filterChips?.filter(f => f.active);

    const activeCategories = activeCategoriesArray?.map(ac => ac.key);
    if (areEqualArray(categories, activeCategories)) return;

    setCategories(activeCategories);
  },[filterChips]);

  useEffect(() => {

    const activeCategoriesArray = movementsFiltersChips?.filter(f => f.active);
    const activeCategories = activeCategoriesArray?.map(ac => ac.key);
    if (activeCategories.includes("INCOME") && !activeCategories.includes("PAYMENTS") && !activeCategories.includes("ALL")) {
      setIsActiveValue(true);
    } else if (activeCategories.includes("PAYMENTS") && !activeCategories.includes("INCOME") && !activeCategories.includes("ALL")) {
      setIsActiveValue(false);
    } else {
      setIsActiveValue(null);
    }
  },[movementsFiltersChips]);

  useEffect(() => {

    if ( dateFrom === currentFilterSelected?.dateFrom &&
      dateTo === currentFilterSelected?.dateTo &&
      isActiveValue === currentFilterSelected?.isActiveValue &&
      includesFilter === currentFilterSelected?.includesFilter &&
      docNumberFilter === currentFilterSelected?.docNumberFilter &&
      accountCodeFilter === currentFilterSelected?.accountCodeFilter &&
      categories === currentFilterSelected?.categories ){
      return;
    }
    // if (isGettingDashboardData) return;
    if (tabActive === 2) {
      dispatch(getAccountedEntries(
        null, null, dateFrom, dateTo, null, includesFilter.length > 0 ? includesFilter : null
      )).then();
    }  else {
      dispatch(getDashboardData(
        null, isFromBankPayments ? ["BANK_TRANSACTION"] : categories, docNumberFilter, accountCodeFilter, includesFilter.length > 0 ? includesFilter : null, isActiveValue, dateFrom, dateTo, uuidCurrentFilter || uuidv4(), tabActive === 2 ? true : false
      )).then((res) => {
        setInitialNexPage(res?._links?.next?.href); // TODO
      });
    }
  }, [isFromBankPayments, dateFrom, dateTo, isActiveValue, includesFilter, docNumberFilter, accountCodeFilter, categories]);

  useEffect(() => {
    if (tabActive === 2) {
      dispatch(getAccountedEntries(
        null, null, dateFrom, dateTo, null, includesFilter.length > 0 ? includesFilter : null
      )).then();
    } else {
      dispatch(getDashboardData(
        null, isFromBankPayments ? ["BANK_TRANSACTION"] : categories, docNumberFilter, accountCodeFilter, includesFilter.length > 0 ? includesFilter : null, isActiveValue, dateFrom, dateTo, uuidCurrentFilter || uuidv4(), tabActive === 2 ? true : false
      )).then((res) => {
        setInitialNexPage(res?._links?.next?.href); // TODO
      });
    }

  }, [dateFrom, dateTo, tabActive]);

  const goToDetail = id => navigate({pathname: `/precog-detail/${id}`, search: location.search},
    {state: {categories: categories,
      docNumberFilter: docNumberFilter,
      accountCodeFilter: accountCodeFilter,
      includesFilter: includesFilter,
      isActiveValue: isActiveValue,
      dateFrom: dateFrom,
      dateTo: dateTo
    }});

  const withholdingDetailAction = (id) => {
    // chiamare il dettaglio
    dispatch(getWithholdingDetail(id));
    setVisibleDrawer(true);
  };

  const openAccountingNotificationSuccess = () => {
    openNotificationWithIcon(
      notification,
      "success",
      "",
      feedbackMessageSuccess,
      null,
      null
    );
  };

  const openAccountingNotificationError = () => {
    openNotificationWithIcon(
      notification,
      "error",
      "",
      feedbackMessageError,
      null,
      null
    );
  };

  const onAccountingSelected = () => {
    dispatch(postRegistrationMultiple(selectedDocuments)).then(() => {
      openAccountingNotificationSuccess();
      setAllChecked(false);
      dispatch(getDashboardData(
        null, isFromBankPayments ? "BANK_TRANSACTION" : categories, docNumberFilter, accountCodeFilter, includesFilter.length > 0 ? includesFilter : null, isActiveValue, dateFrom, dateTo, uuidCurrentFilter || uuidv4(), tabActive === 2 ? true : false
      ));
    }).catch(() => openAccountingNotificationError());
  };

  const onCheckIncludesFilter = (e, value) => {
    if (e.target.checked) {
      setIncludesFilter([...includesFilter, value]);
    } else {
      const includesFilterCopy = [...includesFilter];
      const filteredIncludesFilterCopy = includesFilterCopy.filter(f => f !== value);
      setIncludesFilter(filteredIncludesFilterCopy);
    }
  };

  const onChangeDocDate = value => {
    if (value === null) {
      setDateFrom(null);
      setDateTo(null);
    }
    setDateFrom(value[0] ? moment(value[0]).format("YYYY-MM-DD") : null);
    setDateTo(value[1] ? moment(value[1]).format("YYYY-MM-DD") : null);
  };

  return (
    <div>
      <WidgetsPrecogContainer />
      <>
        <div className="preCog-doc-list-root">
          {/* Bottone spostato by design
          */}
          <div className="preCog-doc-list-body">
            {isGettingDashboardData || isGettingWithholdings && (
              <LoaderSimple style={{marginBottom: "80px",
                position: "fixed", top: "154px",
                backgroundColor: "rgba(256,256,256, 0.7)",
                width: "100%",
                height: "calc(100% - 154px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center", fontSize: "32px", color: "#0090d1"
              }} />
            )}
            <div className="preCog-doc-list-body-col">
              <div className="preCog-doc-list-body-row vaporTab">
                <div>
                  {visibleDrawer && withHoldingDetail && (
                    <WithHoldingDrawerDetail
                      isReadOnly={true}
                      isOnlyWithHolding={true}
                      withholding={withHoldingDetail}
                      setWithHoldingDrawer={() => dispatch({ type: "RESET_WITHHOLDING_DETAIL" })}
                      setVisibleDrawer={setVisibleDrawer}
                      visibleDrawer={visibleDrawer}
                    />
                  )}

                  <SectionHeader tabActive={tabActive} setTabActive={setTabActive} />

                </div>
              </div>
              {tabActive !== 5 && tabActive !== 4 && tabActive !== 1 && tabActive !== 2 && (
                <>
                  <div style={{ display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"}}>

                    <TableFilters
                      filtersList = {
                        /** TODO mancano i filtri BE per ritenute */
                        tabActive === 3 ? ["toPaid", "partially_paid", "paid"] :
                          ["purchase", "sale", "bank_Transaction", "compensation", "documents"]
                      }
                      activeFilters = {activeFilters}
                      setActiveFilters = {setActiveFilters}
                    />

                    {tabActive === 1 && <Button colorScheme={"ghost"} kind={"secondary"} onClick={() => navigate("/precog-create")}>
                      <div style={{display: "flex", alignItems: "center"}}>
                        <FontAwesomeIcon icon={["fal", "plus-circle"]} style={{
                          color: "#0090d1",
                          fontSize: "16px",
                          cursor: "pointer",
                          marginRight: "8px"
                        }}  />
                        <FormattedMessage id="preCog.createAccountingRecord" />
                      </div>
                    </Button>}
                  </div>

                  <Table
                    columns={tabActive === 3 && columnsWithholding(withholdingDetailAction)}
                    dataSource={tabActive === 3 && withholdings}
                    pagination={false}
                  />
                </>
              )}
              {tabActive === 4 && <FixedAsset />}
              {tabActive === 1 && <ToBeAccountantContent
                uuidCurrentFilter={uuidCurrentFilter}
                setUuidCurrentFilter={setUuidCurrentFilter}
                initialNexPage={initialNexPage}
                selectedDocuments={selectedDocuments}
                setSelectedDocuments={setSelectedDocuments}
                filterChips={filterChips}
                setFilterChips={setFilterChips}
                docNumberFilter={docNumberFilter}
                setDocNumberFilter={setDocNumberFilter}
                accountCodeFilter={accountCodeFilter}
                setAccountCodeFilter={setAccountCodeFilter}
                movementsFiltersChips={movementsFiltersChips}
                setMovementsFiltersChips={setMovementsFiltersChips}
                onCheckIncludesFilter={onCheckIncludesFilter}
                includesFilter={includesFilter}
                isActiveValue={isActiveValue}
                onChangeDocDate={onChangeDocDate}
                dateFrom={dateFrom}
                dateTo={dateTo}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                closeMoreFilter={closeMoreFilter}
                setCloseMoreFilter={setCloseMoreFilter}
                monthsSelectValue={monthsSelectValue}
                setMonthsSelectValue={setMonthsSelectValue}
                months={months}
                setMonths={setMonths}
                yearFilter={yearFilter}
                setYearFilter={setYearFilter}
                quarterFilter={quarterFilter}
                setQuarterFilter={setQuarterFilter}
                isBankTransactionActive={isBankTransactionActive}
                setIsBankTransactionActive={setIsBankTransactionActive}
                goToDetail={goToDetail}
                allChecked={allChecked}
                setAllChecked={setAllChecked}
              />
              }
              {tabActive === 2 &&
              <AccountantContent
                tabActive={tabActive}
                categories={categories}
                uuidCurrentFilter={uuidCurrentFilter}
                setUuidCurrentFilter={setUuidCurrentFilter}
                initialNexPage={initialNexPage}
                selectedDocuments={selectedDocuments}
                setSelectedDocuments={setSelectedDocuments}
                filterChips={filterChips}
                setFilterChips={setFilterChips}
                docNumberFilter={docNumberFilter}
                setDocNumberFilter={setDocNumberFilter}
                accountCodeFilter={accountCodeFilter}
                setAccountCodeFilter={setAccountCodeFilter}
                movementsFiltersChips={movementsFiltersChips}
                setMovementsFiltersChips={setMovementsFiltersChips}
                onCheckIncludesFilter={onCheckIncludesFilter}
                includesFilter={includesFilter}
                isActiveValue={isActiveValue}
                onChangeDocDate={onChangeDocDate}
                dateFrom={dateFrom}
                dateTo={dateTo}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                closeMoreFilter={closeMoreFilter}
                setCloseMoreFilter={setCloseMoreFilter}
                monthsSelectValue={monthsSelectValue}
                setMonthsSelectValue={setMonthsSelectValue}
                months={months}
                setMonths={setMonths}
                yearFilter={yearFilter}
                setYearFilter={setYearFilter}
                quarterFilter={quarterFilter}
                setQuarterFilter={setQuarterFilter}
                isBankTransactionActive={isBankTransactionActive}
                setIsBankTransactionActive={setIsBankTransactionActive}
                goToDetail={goToDetail}
              />
              }

            </div>

          </div>
        </div>
        <>
          {tabActive === 1 &&
            <footer className="precog-toBeAccountant-footer">
              <Button kind="primary" size="large" onClick={() => onAccountingSelected()} disabled={selectedDocuments?.length === 0}>
                {" "}
                <FormattedMessage id="preCog.accountingTab.accountingSelected" />{" "}
              </Button>
            </footer>
          }
        </>
      </>
    </div>
  );
};
export default PreCogPage;
